import { OrderButtons } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/order-buttons';

export const DumpsterSizesHeroSection = () => {
  return (
    <section className="relative bg-gray-900 text-white py-20 md:py-32">
      {/* Background image overlay */}
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('/redebins/images/hero-background.jpg')",
          }}
        />
        <div className="absolute inset-0 bg-black/50" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 italic">
            Dumpster Sizes: 5-Yard vs. 10-Yard — Which Do You Need?
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Not sure which bin is right for your project? Here&apos;s everything
            you need to choose with confidence — or just call us and we&apos;ll
            tell you in 30 seconds.
          </p>

          {/* Order Buttons */}
          <OrderButtons />

          {/* Help me choose anchor */}
          <div className="mt-6">
            <a
              href="#which-size-section"
              className="text-white/80 hover:text-white underline underline-offset-4 transition-colors text-sm md:text-base"
            >
              Not sure? Help me choose ↓
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
